import { defineComponent as v, createBlock as f, openBlock as b, unref as n, withCtx as r, renderSlot as o, normalizeProps as l, guardReactiveProps as s, createVNode as u } from "vue";
import { RevButtonIcon as x } from "@ds/components/ButtonIcon";
import { RevCarousel as g } from "@ds/components/Carousel";
import { RevModalBase as k } from "@ds/components/ModalBase";
import p from "../../icons/generated/IconCross.vue2.js";
import { useI18n as I } from "@ds/plugin";
import B from "../../translations/generic.translations.js";
import { tw as C } from "../../utils/tailwind.js";
const h = /* @__PURE__ */ v({
  name: "RevMediaViewer",
  __name: "MediaViewer",
  props: {
    name: {},
    alternativeButtonLabel: {},
    alternativeNext: {},
    currentIndexId: {},
    tracking: { default: () => ({}) },
    alternativePrevious: {},
    thumbnails: {},
    closeButtonLabel: { default: () => {
    } },
    to: { default: "body" },
    backdropZIndex: { default: () => {
    } },
    currentIndex: {}
  },
  emits: ["open", "close"],
  setup(e) {
    const d = I(), m = e.closeButtonLabel || d(B.buttonClose), c = C`absolute top-1/2 size-full -translate-y-1/2 object-contain`;
    return (a, i) => (b(), f(n(k), {
      "backdrop-z-index": e.backdropZIndex,
      class: "safari-mobile-26:pb-0 bg-overlap-default-low fixed inset-0 m-auto flex items-center justify-center p-24 md:rounded-lg md:inset-32 lg:max-w-1376",
      name: e.name,
      to: e.to,
      onClose: i[0] || (i[0] = (t) => a.$emit("close", t)),
      onOpen: i[1] || (i[1] = (t) => a.$emit("open"))
    }, {
      default: r(({ close: t }) => [
        u(n(g), {
          "alternative-button-label": e.alternativeButtonLabel,
          "alternative-next": e.alternativeNext,
          "alternative-previous": e.alternativePrevious,
          class: "size-full",
          "current-index": e.currentIndex,
          "current-index-id": e.currentIndexId,
          thumbnails: e.thumbnails,
          tracking: e.tracking
        }, {
          default: r(() => [
            o(a.$slots, "default", l(s({ imgClassNames: c })))
          ]),
          _: 3
        }, 8, ["alternative-button-label", "alternative-next", "alternative-previous", "current-index", "current-index-id", "thumbnails", "tracking"]),
        u(n(x), {
          "alternative-text": n(m),
          class: "absolute right-12 top-12",
          icon: n(p),
          variant: "secondary",
          onClick: () => t({ cause: "dismiss" })
        }, null, 8, ["alternative-text", "icon", "onClick"])
      ]),
      trigger: r(({ open: t }) => [
        o(a.$slots, "trigger", l(s({ open: t })))
      ]),
      _: 3
    }, 8, ["backdrop-z-index", "name", "to"]));
  }
});
export {
  h as default
};
